export const CardsBusinessIcon = () => {
  return (
    <svg width='19' height='18' viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_13774_31684'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='19'
        height='18'
      >
        <rect x='0.882812' y='0.382812' width='17.2308' height='17.2308' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_13774_31684)'>
        <path
          d='M2.58203 15.1579V2.59375H9.40236V5.46554H16.4162V15.1579H2.58203ZM3.65877 14.0809H8.32562V12.2861H3.65877V14.0809ZM3.65877 11.2091H8.32562V9.41426H3.65877V11.2091ZM3.65877 8.33734H8.32562V6.54247H3.65877V8.33734ZM3.65877 5.46554H8.32562V3.67067H3.65877V5.46554ZM9.40236 14.0809H15.3394V6.54247H9.40236V14.0809ZM10.9765 9.41426V8.33734H13.6273V9.41426H10.9765ZM10.9765 12.2861V11.2091H13.6273V12.2861H10.9765Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
};
